<template>
  <div class="aggregation-list">
    <ul v-if="data && data.length">
      <li
        v-for="(item, index) in data"
        :key="index"
        class="one clearfix"
      >
        <span class="name">{{ item.name }}</span>
        <span class="transfer-icon"> <i class="iconfont iconicon-test89 " /> </span>

        <a-cascader
          v-if="row.currField && (row.currField.fieldtype === 'select_user' || row.currField.fieldtype === 'select_reception')"
          :value="item.selectVal || []"
          :show-search="true"
          :options="newOptions"
          :placeholder="selectPlaceholder"
          @change="handleChangeCascader($event, item)"
        />
        <a-tree-select
          v-else-if="row.currField && row.currField.fieldtype === 'select_tree'"
          :value="item.selectVal + '' || ''"
          :tree-data="newOptions"
          :placeholder="selectPlaceholder"
          tree-default-expand-all
          tree-node-filter-prop="title"
          @change="handleChangeTree($event, item)"
        />
        <a-select
          v-else
          :value="item.selectVal || undefined"
          style="width: 320px"
          :placeholder="selectPlaceholder"
          @change="handleChangeSelect($event, item)"
        >
          <a-select-option
            v-for="(one) in newOptions"
            :key="one.id"
            :value="one.id"
          >
            {{ one.fieldname || one.name }}
          </a-select-option>
        </a-select>
      </li>
    </ul>
    <div
      v-else
      class="loading-box"
    >
      <a-spin />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    row: {
      type: Object,
      default: () => ({})
    },
    getOptions: {
      type: Function,
      default: () => {}
    }
  },

  data () {
    return {
    }
  },

  computed: {
    // 树形下拉和下拉处理列表数据
    newOptions () {
      let { options = [] } = this
      let { currField = {} } = this.row || {}
      let { fieldtype = '' } = currField

      if (fieldtype !== 'select_user' && options[0] && options[0].name.indexOf(this.$t('message["437"]')) === -1) {
        options.unshift({
          name: `-${this.$t('message["437"]')}-`,
          label: `-${this.$t('message["437"]')}-`,
          fieldname: `-${this.$t('message["437"]')}-`,
          title: `-${this.$t('message["437"]')}-`,
          id: 'ignore'
        })
      }

      if (fieldtype === 'select_tree') {
        this.setTreeOptions(options)
      } else if (fieldtype === 'radioinfo_level') {
        options = this.setLevelOptions(JSON.parse(JSON.stringify(options)))
      } else if (fieldtype === 'select_reception') {
        options = this.setReceptionOptions(JSON.parse(JSON.stringify(options)))
      }

      console.log(options)
      return options
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    }
  },

  methods: {
    // 处理需求设备等树形下拉数据
    setTreeOptions (options) {
      for (let item of options) {
        item.title = item.name
        item.id = item.id + ''
        item.value = item.id
        item.key = (item.pId || 0) + '-' + item.id
        if (item.children || item.child) {
          item.children = item.children || item.child || []
          for (let child of item.children) {
            child.pId = (item.pId || 0) + '-' + item.id
            child.pName = item.pName + '/' + item.name
          }
          this.setTreeOptions(item.children)
        }
      }
    },

    setLevelOptions (options) {
      const { fieldconfig = {} } = this.row.currField
      const { type } = fieldconfig
      let arr = []
      if (type === 1) {
        arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
      } else if (type === 2) {
        arr = this.$t('message["1444"]').split(',')
      }
      options.forEach((item, i) => {
        if (item.id === 'ignore') {
          options.splice(i, 1)
        }
      })
      options.forEach((item, i) => {
        item.name = arr[i]
      })
      return options
    },
    // 处理接待方式下拉数据
    setReceptionOptions (options) {
      for (let item of options) {
        item.label = item.name || item.fieldname
        let value = item.id === undefined ? item.fieldkey : item.id
        item.value = value
        item.key = item.pId + '-' + item.value
        item.children = item.children || item.child || []
        if (!item.children.length) {
          delete item.children
        }
        if (item.children && item.children.length) {
          item.children = item.children.filter(o => o && o.status !== -7)
          for (let child of item.children) {
            child.pId = item.pId + '-' + (item.id || item.fieldkey)
          }
          this.setReceptionOptions(item.children)
        }
      }
      return options
    },

    handleChangeSelect (value, item) {
      if (!value) return

      item.selectVal = value || undefined
      this.$emit('change', value, item.name)
    },

    handleChangeCascader (value, item) {
      item.selectVal = value || []
      this.$emit('change', value, item.name)
    },

    handleChangeTree (value, item) {
      item.selectVal = value + '' || ''
      this.$emit('change', value, item.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.aggregation-list {
  .one {
    margin-bottom: 16px;
    padding: 0 56px;
    line-height: 32px;
  }
  .name {
    float: left;
    width: 112px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: right;
  }
  .transfer-icon {
    float: left;
    width: 56px;
    text-align: center;
    color: #d6d6d6;
  }
  .ant-select {
    float: left;
  }
  .loading-box {
    text-align: center;
  }
}
</style>
